import React from "react";
import { colors, spacing } from "./theme";

export default function Section({
  title,
  subtitle,
  actions,
  children,
  style = {}
}) {
  return (
    <section
      style={{
        marginBottom: spacing["2xl"],
        ...style
      }}
    >
      {(title || subtitle || actions) && (
        <div style={headerStyle}>
          <div>
            {title && <h2 style={titleStyle}>{title}</h2>}

            {subtitle && (
              <p style={subtitleStyle}>
                {subtitle}
              </p>
            )}
          </div>

          {actions && <div>{actions}</div>}
        </div>
      )}

      {children}
    </section>
  );
}

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: spacing.lg,
  marginBottom: spacing.lg,
  flexWrap: "wrap"
};

const titleStyle = {
  margin: 0,
  color: colors.text,
  fontSize: 22,
  fontWeight: 700
};

const subtitleStyle = {
  marginTop: 6,
  marginBottom: 0,
  color: colors.textMuted,
  fontSize: 14
};